module.exports = __webpack_public_path__ + "img/role_button1.bb6ee4c1.png";